import { Form, PageHeader } from 'antd'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'

import FormBlock from '../../components/forms/FormBlock'
import FormWrap from '../../components/forms/FormWrap'
import Error from '../../components/Error'
import Loader from '../../components/Loader'
import {
  FixedDesignDescriptionForm,
  FixedDesignOptionsForm,
} from '../../forms/FixedDesign'
import { getFixedDesignById, updateFixedDesign } from '../../network/FixedDesign'
import { Details } from './CreateFixedDesign'
import { createUrlWithFiltersFromCurrentURL } from '../../utils/filterUtils'
import { useAuth } from '../../hooks/useAuth'
import { validateOptionSubOptionRefs } from './utils/optionValidators'

const EditFixedDesign = ({ history }) => {
  const [form] = Form.useForm()
  const { id } = useParams()
  const { user } = useAuth()

  const fixDesignDetails = useQuery(
    ['getFixedDesignById', { id }],
    getFixedDesignById,
    { refetchOnWindowFocus: false, enabled: !!id }
  )

  useEffect(() => {
    if (fixDesignDetails.data) {
      form.resetFields()
      const data = { ...fixDesignDetails.data }
      if (!data.details || !Array.isArray(data.details) || data.details.length === 0) {
        data.details = [{}]
      }
      form.setFieldsValue(data)
    }
  }, [fixDesignDetails.data, form])

  if (fixDesignDetails.isError) {
    return (
      <>
        <PageHeader
          className="site-page-header"
          title="Edit fixed design"
          onBack={() => history.push(createUrlWithFiltersFromCurrentURL('/fixed-designs'))}
        />
        <Error retry={() => fixDesignDetails.refetch()} />
      </>
    )
  }

  if (fixDesignDetails.isLoading || !fixDesignDetails.data) {
    return (
      <>
        <PageHeader
          className="site-page-header"
          title="Edit fixed design"
          onBack={() => history.push(createUrlWithFiltersFromCurrentURL('/fixed-designs'))}
        />
        <Loader />
      </>
    )
  }

  return (
    <>
      <PageHeader
        className="site-page-header"
        title="Edit fixed design"
        onBack={() => history.push(createUrlWithFiltersFromCurrentURL('/fixed-designs'))}
        style={{ backgroundColor: '#fff' }}
      />
      <FormWrap
        key={id}
        id={id}
        form={form}
        title="update_fixed_design"
        request={updateFixedDesign}
        cancelText="Cancel"
        okText="Save"
        data={fixDesignDetails.data}
        onSuccess={() => history.push(createUrlWithFiltersFromCurrentURL('/fixed-designs'))}
        onCancel={() => history.push(createUrlWithFiltersFromCurrentURL('/fixed-designs'))}
        cleanBeforeSending={(oldData) => {
          const payload = {
            name: oldData.name || {},
            sku: oldData.sku,
            description: oldData.description || {},
            category: oldData.category,
            store: user?.currentStore,
            options: (oldData.options || []).map((opt) => ({
              name: opt.name || {},
              freeField: !!opt.freeField,
              subOptions: (opt.subOptions || []).map((sub) => ({
                name: sub.name || {},
                ref: sub.ref,
              })),
            })),
            details: oldData.details || [],
          }
          return payload
        }}
        invalidate={['getFixedDesigns', 'getFixedDesignById']}
      >
        <div className="section-from-vertical">
          <FormBlock form={form} formTemplate={FixedDesignDescriptionForm} />
          <Details form={form} />
          <Form.Item
            name="options"
            rules={[{ validator: validateOptionSubOptionRefs }]}
          >
            <FormBlock form={form} formTemplate={FixedDesignOptionsForm} />
          </Form.Item>
        </div>
      </FormWrap>
    </>
  )
}

export default EditFixedDesign
